import { render, staticRenderFns } from "./mandate-modal.vue?vue&type=template&id=2b9135d8&"
import script from "./mandate-modal.vue?vue&type=script&lang=js&"
export * from "./mandate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports